import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Badge } from '@mui/material'
import moment from 'moment'
import { ApprovalResult } from '@global/types'
import { CvsAvatar } from '../../CvsAvatar'
import { DatasetStatus, PendingStatus } from '../types'
import * as css from './styles'

interface Props {
  label: DatasetStatus | PendingStatus | null
  approvalResult: ApprovalResult
  size?: number
}

export const ApprovalDetails = ({ approvalResult, label, size }: Props) => {
  const { user, created_at } = approvalResult
  const badgeContent = getBadgeContent(label)

  const approvalActionText = (() => {
    const formattedDate = moment(created_at).format('MMMM DD')
    const approvalActionText = `${label} by ${user?.name} on ${formattedDate}`

    return <css.Text>{approvalActionText}</css.Text>
  })()

  return (
    <css.Container data-testid="approval-details-container">
      {user !== null && (
        <Badge
          overlap="circular"
          css={css.badge}
          badgeContent={badgeContent}
          data-testid="approval-badge"
        >
          <CvsAvatar user={user} compact size={size} />
        </Badge>
      )}
      {Boolean(created_at) && approvalActionText}
    </css.Container>
  )
}

function getBadgeContent(label) {
  switch (label) {
    case DatasetStatus.APPROVED:
      return <CheckCircleIcon color="secondary" css={css.icon} data-testid="check-circle-icon" />
    case PendingStatus.REJECTED:
      return <CancelIcon color="error" css={css.icon} data-testid="cancel-icon" />
    default:
      return null
  }
}
